import { create } from "zustand";

type State = {
  isTradeCreationBusy: boolean;
};

type Action = {
  // eslint-disable-next-line no-unused-vars
  setIsTradeCreationBusy: (value: boolean) => void;
  // eslint-disable-next-line no-unused-vars
};

const tradeCreationInProcessStore = create<State & Action>((set) => ({
  isTradeCreationBusy: false,
  setIsTradeCreationBusy: (value: boolean) => {
    set(() => ({
      isTradeCreationBusy: value,
    }));
  },
}));

export default tradeCreationInProcessStore;
